import { render, staticRenderFns } from "./FivGoalsFilter.vue?vue&type=template&id=057d75a9"
import script from "./FivGoalsFilter.vue?vue&type=script&lang=ts"
export * from "./FivGoalsFilter.vue?vue&type=script&lang=ts"
import style0 from "./FivGoalsFilter.vue?vue&type=style&index=0&id=057d75a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports